<template>
    <div class="article__loading">
        <div class="article__spinner"></div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'ArticleRelocator',
    methods: {
        routeUpdate() {
            try {
                window.document.location = this.$options.filters.cr('site_br_pages') + '/' + (this.$route.params.slug || '');
            } catch (error) {
                console.error('Error reviewing content:', error);
            } finally {
                document.title = 'Bridgerocks | ' + (this.fullContent?.title || this.$route.params.slug || 'Page');
            }
        }
    },
    watch: {
        '$route.params.slug'() {
            this.routeUpdate()
        }
    },
    beforeMount() {
        this.routeUpdate()
    }
};
</script>